import { isSumaho } from '../common/isSumaho';
import { searchCalendar } from './setCalendar';
import { switchLink } from './switchLink';
import { getEachSiteRouteLayers } from './getEachSiteRouteLayers';

/**
 * @description 予約モジュール
 */
export function reservation(): void {
  const url = `/${getEachSiteRouteLayers()}/common/reservation/index.html`;
  $.ajax({
    url: url,
  })
    .done((data) => {
      $('head').prepend('<link href="https://d2ahiw9kb7is19.cloudfront.net/Assets/Mystays/booking-engine/app.css" rel="stylesheet">');
      $('.js-booking').append(data);
      switchLink();

      const target = $('.js-reserve-fujitu');
      if (!target.length) return;

      searchCalendar();
      setReserveParam();
      copyText();
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      console.error(`予約モジュール読み込みエラー: ${jqXHR.status}, ${textStatus}, ${errorThrown}`, jqXHR.responseText);
    });
}

// 富士通searchlink ex)
// https://reserve.kanponoyado.japanpost.jp/rsvsearch/rsvsearchcalendar.aspx?a_cd=0030&o_cd=33120&d_st=20220902&d_cn=1&a_cn=2&c1_cn=0&c2_cn=0&t_cn=1

// 富士通sp ex)
// https://reserve.kanponoyado.japanpost.jp/sm/rsvsearch/rsvsearchcalendar.aspx?a_cd=0030&o_cd=33120&d_st=20220902&d_cn=1&a_cn=2&c1_cn=0&c2_cn=0&t_cn=1

/**
 * @description a_cd:地域コード,o_cd:施設コード,d_st:宿泊開始日,d_cn:拍数,a_cn:大人,c1_csn:お子様,c2_cn:幼児,t_cn:部屋数
 */

const setReserveParam = () => {
  let link = $('.js-search-param').attr('href')!;
  const hotelcode = link.split('?')[1];

  if (isSumaho()) {
    link = `https://reserve.kanponoyado.japanpost.jp/sm/rsvsearch/rsvsearchcalendar.aspx?${hotelcode}`;
    $('.js-search-param').attr('href', link);
  }

  $('.js-search-param').on('click', () => {
    const [stay, adult, child, child2, room] = [$('.js-stay').val(), $('.js-adult').val(), $('.js-child').val(), $('.js-child2').val(), $('.js-room').val()];
    let day = $('.js-calendar').val()?.toString()!;
    day = day.replace(/\//g, '');
    const param = `&d_st=${day}&d_cn=${stay}&a_cn=${adult}&c1_cn=${child}&c2_cn=${child2}&t_cn=${room}`;

    $('.js-search-param').attr('href', `${link}${param}`);
  });
};

//pc,spで表示箇所がかなり異なるため
const copyText = () => {
  $('.js-reserve-detail-text-sp').html($('.js-reserve-detail-text').html());
};
